import moment from "moment";

// Classes
import DateTime from "../classes/DateTime";

export default interface IPatientDetails {
	givenName: string;
	middleName: string;
	familyName: string;
	yearOfBirth: string;
	monthOfBirth: string;
	dateOfBirth: string;
	mobile: string;
	notes: string;
	attendancePreference: string;
	mobileFormat: string;
	isTelehealth: boolean;
	isNewPatient: boolean;
	isPersonBooking: boolean;
	email: string;
	isStudent: boolean;
	institutionName: string;
	studentNumber: string;
	studentNumberExpiry: string;
	hasMedicare: boolean;
	hasConcession: boolean;
	sex: string;
	gender: string;
	telehealthRestrictionAcknowledged?: boolean;
}

export const InitialPatientDetails: IPatientDetails = {
	givenName: "",
	middleName: "",
	familyName: "",
	yearOfBirth: "",
	monthOfBirth: "",
	dateOfBirth: "",
	mobile: "",
	notes: "",
	attendancePreference: "on-site",
	mobileFormat: "aus",
	isTelehealth: false,
	isNewPatient: false,
	isPersonBooking: true,
	email: "",
	isStudent: false,
	institutionName: "",
	studentNumber: "",
	studentNumberExpiry: moment().format(DateTime.DEFAULT_DATE_FORMAT),
	hasMedicare: false,
	hasConcession: false,
	sex: "",
	gender: "",
};
